import { render, staticRenderFns } from "./SuratKetSakit.vue?vue&type=template&id=a9339ba4&"
import script from "./SuratKetSakit.vue?vue&type=script&lang=js&"
export * from "./SuratKetSakit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports